import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import IndexDetailView from 'src/components/Dashboard/components/IndexDetailView';
import ReferralsInReviewIndex from 'src/components/Dashboard/components/Referrals/ReferralsInReviewIndex';
import { fetchDashboardReferrals } from 'actions/Referral/Group';
import { fetchGroupsPrograms } from 'actions/Program/Group';
import _ from 'lodash';
import DetailView from 'src/components/Dashboard/components/DetailView';
import ReferralDetail from 'src/components/Referrals/ReferralDetail/index';
import fetchProvidersUserCore from 'src/actions/UserProvider/fetchProvidersUser';
import { noneAssignedOption, careCoordinatorFilterDefault } from 'src/components/Dashboard/utils/filterDefaults';
import { getDataOfPage, isDataValid, getResponsePageMismatch } from 'src/components/Dashboard/utils/dataHelpers';
import appendReferralIdToLocation from 'src/components/Dashboard/utils/appendReferralIdToLocation';
import { goToReferral } from 'src/components/Referrals/utils/routing';
import { serviceTypesFilter, careCoordinatorsFilter, programsFilter } from 'src/components/Dashboard/utils/filter';
import { getGroupUsersOptions } from 'src/components/Groups/Users/utils';
import { getProgramsOptions } from 'src/components/Groups/Programs/utils';
import { getReasonsOptions } from 'src/components/Groups/utils';
import { isReferralsAdminAndAbove } from 'src/components/User/utils';
import FeatureFlagContainer from 'src/common/utils/FeatureFlags/FeatureFlagContainer';
import { crtb2646ShowProgramNameReferralsCasesDashboard } from 'src/common/utils/FeatureFlags/flags';
import labelCustomization from 'src/common/utils/Customization/labels';
import defaultLabels from 'src/constants/labels';
import { loadDashboardSortingConfiguration } from 'src/components/Dashboard/utils/userSortingHandler';
import { browserHistory } from 'common/utils/browserHistory';
import { createSortChangeHandler } from 'src/components/Dashboard/utils/sortHelpers';

export class ReferralsInReview extends Component {
  constructor(props) {
    super(props);
    this.onCellClick = this.onCellClick.bind(this);
    this.onFiltersChange = this.onFiltersChange.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.shouldFetch = this.shouldFetch.bind(this);
    this.fetch = this.fetch.bind(this);
    this.fetchGroupsUsers = this.fetchGroupsUsers.bind(this);
    this.fetchProgramsSearch = this.fetchProgramsSearch.bind(this);
    this.fetchRequestId = 0;
    const sortObj = loadDashboardSortingConfiguration(browserHistory.getCurrentLocation().pathname);
    this.state = {
      activeUsersInGroup: [],
      activePrograms: [],
      page: 1,
      sidx: sortObj?.column || 'received_at',
      sord: sortObj?.sortDirection || 'desc',
      filters: {
        service_types: _.get(props, 'filters.service_types', []),
        care_coordinator_users: _.get(
          props,
          'filters.care_coordinator_users',
          careCoordinatorFilterDefault(props.userId, props.isCaseManager && props.isCC),
        ),
        programs: _.get(props, 'filters.programs_filter', []),
        reasons: _.get(props, 'filters.reasons', []),
      },
    };
  }

  componentDidMount() {
    if (isReferralsAdminAndAbove(this.props.user, this.props.groupId)) {
      this.fetch();
    }
    // TODO: circle back to this and get a utility function created
    this.props.fetchProvidersUserCore({
      providers: this.props.groupId,
    }).then((response) => {
      if (response) {
        const { employees: activeUsersInGroup } = response;
        this.setState({ activeUsersInGroup });
      }
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.refetch && nextProps.refetch) {
      this.fetch(this.state.page);
    }
  }

  onSortChange = createSortChangeHandler(this);

  onCellClick(row) {
    const pagedData = getDataOfPage(this.props.referralsInReview, this.state.page);
    const referral = pagedData.data[row];

    goToReferral(referral);
  }

  onFiltersChange(key, activeFilters, callbacks) {
    let newFilters = activeFilters;
    if (_.isEqual(key, 'care_coordinator_users')) {
      newFilters = careCoordinatorsFilter(activeFilters, callbacks);
    }
    if (_.isEqual(key, 'programs_filter')) {
      newFilters = programsFilter(activeFilters, callbacks);
    }

    this.setState({
      page: 1,
      filters: _.assign({}, this.state.filters, { [key]: newFilters }),
    }, () => {
      this.fetch();
    });
  }

  onNextClick() {
    const page = this.state.page + 1;
    this.fetch(page);
  }

  onPrevClick() {
    const page = this.state.page - 1;
    this.fetch(page);
  }

  shouldFetch(page) {
    if (isDataValid(this.props.referralsInReview, page)) {
      this.setState({ page });
    } else {
      this.fetch(page);
    }
  }

  fetch(page = 1) {
    const requestId = this.fetchRequestId + 1;
    this.fetchRequestId = requestId;
    this.setState({ page });
    const referralsPromise = Promise.resolve(this.props.fetchDashboardReferrals(
      this.props.groupId,
      'received/in-review',
      {
        target: 'referralsInReview',
        sidx: this.state.sidx,
        sord: this.state.sord,
        filters: this.state.filters,
        page,
      },
      'in_review',
      'received',
    )).then((response) => {
      if (requestId !== this.fetchRequestId) {
        return response;
      }

      const responsePage = getResponsePageMismatch(response, page);
      if (responsePage !== null) {
        this.setState({ page: responsePage });
      }

      return response;
    });
    return Promise.all([
      referralsPromise,
      this.props.fetchGroupsPrograms(this.props.groupId, { active: true }),
    ]).then(([, res]) => {
        this.setState({ activePrograms: res.data.data });
        return getProgramsOptions(res.data.data, this.state);
      });
  }

  fetchProgramsSearch(query = null) {
    return this.props.fetchGroupsPrograms(this.props.groupId, { active: true, query })
      .then((res) => {
        this.setState({ activePrograms: res.data.data });
        return getProgramsOptions(res.data.data, this.state);
      });
  }

  fetchGroupsUsers(search = '') {
    const { groupId } = this.props;
    return this.props.fetchProvidersUserCore({
      providers: groupId,
      options: { text: search },
    }).then((response) => {
      if (response) {
        const { employees: activeUsersInGroup } = response;
        if (search === '') {
          return _.concat(
            [noneAssignedOption(this.state.filters.care_coordinator_users)],
            getGroupUsersOptions(activeUsersInGroup, this.state),
          );
        }

        return getGroupUsersOptions(activeUsersInGroup, this.state);
      }

      return [];
    });
  }

  render() {
    const {
      referralsInReview,
      isFetching,
      isCC,
      baseLocation,
      params,
      serviceTypes,
      reasons,
      labels,
    } = this.props;
    const { activePrograms, activeUsersInGroup } = this.state;
    const location = appendReferralIdToLocation(baseLocation, params);

    let filters = [
      serviceTypesFilter(serviceTypes, this.state.filters.service_types),
    ];
    filters = _.concat(filters, [
      {
        key: 'care_coordinator_users',
        name: labels.CareCoordinator,
        pluralName: `${labels.CareCoordinator}s`,
        options: _.concat(
          [noneAssignedOption(this.state.filters.care_coordinator_users)],
          getGroupUsersOptions(activeUsersInGroup, this.state),
        ),
      },
      {
        key: 'programs_filter',
        name: 'Program',
        pluralName: 'Programs',
        options: getProgramsOptions(activePrograms, this.state),
        asyncSearch: this.fetchProgramsSearch,
      },
      {
        key: 'reasons',
        name: 'Reason',
        pluralName: 'Reasons',
        options: getReasonsOptions(reasons, this.state),
      },
    ]);

    const innerContentView = (
      <ReferralDetail
        subjectType="referral"
        key={params.id}
        location={location}
        params={params}
        type="referralsInReview"
        showContactColumn
      />
    );

    const referralsInReviewDetailView = (
      <DetailView
        innerContentView={innerContentView}
      />
    );
    const pagedData = getDataOfPage(referralsInReview, this.state.page);

    return (
      <>
        <h1 className="sr-only" id="inbound-referrals-in-review-heading">Inbound Referrals In Review</h1>
        <IndexDetailView
          params={this.props.params}
          DetailView={referralsInReviewDetailView}
          IndexView={ReferralsInReviewIndex}
          data={pagedData.data}
          paging={pagedData.paging}
          isFetching={isFetching || pagedData.invalidated}
          onNextClick={this.onNextClick}
          onPrevClick={this.onPrevClick}
          onCellClick={this.onCellClick}
          initialSort={{ [this.state.sidx]: this.state.sord }}
          isCC={isCC}
          onFiltersChange={this.onFiltersChange}
          filters={_.sortBy(filters, 'name')}
          fetchGroupsUsers={this.fetchGroupsUsers}
          showProgramNameColumn={this.props.showProgramNameColumn}
          sortConfig={{ sidx: this.state.sidx, sord: this.state.sord }}
          setSort={this.onSortChange}
        />
      </>
    );
  }
}

ReferralsInReview.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  fetchDashboardReferrals: PropTypes.func.isRequired,
  fetchGroupsPrograms: PropTypes.func.isRequired,
  referralsInReview: PropTypes.shape({
    data: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  userId: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  groupId: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isCC: PropTypes.bool.isRequired,
  baseLocation: PropTypes.string.isRequired,
  serviceTypes: PropTypes.array.isRequired,
  reasons: PropTypes.array.isRequired,
  fetchProvidersUserCore: PropTypes.func.isRequired,
  refetch: PropTypes.bool.isRequired,
  isCaseManager: PropTypes.bool.isRequired,
  labels: PropTypes.object,
  showProgramNameColumn: PropTypes.bool.isRequired,
};

ReferralsInReview.defaultProps = {
  labels: defaultLabels,
};

function mapStateToProps(state, ownProps) {
  return {
    baseLocation: ownProps.location.pathname,
    groupId: _.get(state, 'session.groupId'),
    referralsInReview: _.get(state, 'dashboard.referralsInReview', {}),
    filters: _.get(state, 'dashboard.referralsInReview.filters', {}),
    isFetching: _.get(state, 'dashboard.referralsInReview.isFetching', false),
    isCC: _.wget(state, 'session.isCoordinationGroup', false),
    serviceTypes: _.wget(state, 'serviceTypes.allNetworks', []),
    reasons: _.wget(state, 'session.enums.referrals.hold', []),
    refetch: _.get(state, 'dashboard.refetch'),
    userId: _.wget(state, 'user.id', null),
    user: _.wget(state, 'user', {}),
    token: _.get(state, 'session.token', ''),
    labels: labelCustomization(state),
    showProgramNameColumn: crtb2646ShowProgramNameReferralsCasesDashboard(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({ fetchDashboardReferrals, fetchGroupsPrograms, fetchProvidersUserCore }, dispatch),
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FeatureFlagContainer(ReferralsInReview));
